import {
  isDuplicateFolderName,
  normalizeFolderName,
} from "./contentFolderUtils";

const IGNORED_DIRECTORY_SEGMENTS = new Set(["__MACOSX", ".git"]);

export const getFileExtension = (fileName = "") => {
  const name = String(fileName);
  const lastDotIndex = name.lastIndexOf(".");
  if (lastDotIndex <= 0) return "";
  return name.slice(lastDotIndex + 1).toLowerCase();
};

export const isIgnoredDirectoryFile = (file) => {
  const relativePath = file?.webkitRelativePath || file?.name || "";
  const segments = String(relativePath).split(/[/\\]/).filter(Boolean);
  const fileName = segments[segments.length - 1] || "";
  if (!fileName || fileName.startsWith(".")) return true;
  return segments.some((segment) => IGNORED_DIRECTORY_SEGMENTS.has(segment));
};

export const getSelectedDirectoryName = (files = []) => {
  const relativePath = Array.from(files).find(
    (file) => file?.webkitRelativePath
  )?.webkitRelativePath;
  if (!relativePath) return "";

  const [folderName] = String(relativePath).split(/[/\\]/);
  return normalizeFolderName(folderName);
};

export const isAcceptedUploadFile = ({ file, acceptedFormats = [] }) => {
  if (!file || isIgnoredDirectoryFile(file)) return false;

  const mimeSubtype = String(file.type || "")
    .split("/")[1]
    ?.toLowerCase();
  const extension = getFileExtension(file.name);

  return (
    acceptedFormats.includes(extension) ||
    Boolean(mimeSubtype && acceptedFormats.includes(mimeSubtype))
  );
};

export const findFolderIDByName = ({ folders = [], parentFolderID, name }) => {
  const match = folders.find((folder) =>
    isDuplicateFolderName({
      folders: [folder],
      parentFolderID,
      name,
    })
  );

  return match?.id || null;
};
